/**
 * App.tsx — CLI-450/451/452
 * Маршрутизация кабинета пациента.
 * /login → LoginPage (публичная)
 * /portal/* → PortalLayout (protected: requirePatient в store)
 */
import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { LoginPage }       from './pages/LoginPage';
import { PortalLayout }    from './pages/PortalLayout';
import { DashboardPage }   from './pages/DashboardPage';
import { DocumentsPage }   from './pages/DocumentsPage';
import { LabResultsPage }  from './pages/LabResultsPage';
import { StudiesPage }     from './pages/StudiesPage';
import { AppointmentsPage } from './pages/AppointmentsPage';
import { BookingPage }     from './pages/BookingPage';
import { NotificationsPage } from './pages/NotificationsPage';

// Spinner
function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-primary-400 border-t-primary-700 rounded-full animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* Кабинет пациента — защищён через PortalLayout */}
        <Route path="/portal" element={<PortalLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="documents"    element={<DocumentsPage />} />
          <Route path="lab"          element={<LabResultsPage />} />
          <Route path="studies"      element={<StudiesPage />} />
          <Route path="appointments" element={<AppointmentsPage />} />
          <Route path="book"         element={<BookingPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
        </Route>

        {/* Redirect корня */}
        <Route path="/" element={<Navigate to="/portal" replace />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Routes>
    </Suspense>
  );
}
